function initialize() {
    const selectLang = document.querySelector('.dropdown-select-lang');
    const selectLangMobile = document.querySelector('.select-lang');

    if (!selectLang) {
        return;
    }

    selectLang.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        selectLang.classList.toggle('is-open');
    });

    const langLinks = selectLang.querySelectorAll('.list-lang a');
    langLinks.forEach(function (link) {
        link.addEventListener('click', function (evt) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            selectLanguage(link.getAttribute('data-lang'));
        });
    });

    const langLinksMobile = selectLangMobile.querySelectorAll('.select-lang a');
    langLinksMobile.forEach(function (link) {
        link.addEventListener('click', function (evt) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            selectLanguage(link.getAttribute('data-lang'));
        });
    });

    document.body.addEventListener('click', function () {
        selectLang.classList.remove('is-open');
    });
}

function selectLanguage(lang) {
    var hrefLang = document.querySelector('link[data-lang="' + lang + '"]');

    if (hrefLang) {
        window.location = hrefLang.getAttribute('href');
    } else if (lang == 'pt_BR') {
        window.location = base_url;
    } else {
        window.location = base_url + lang;
    }
}

initialize();
